import { Helpers } from '../../helpers';
import { ICostCode } from '../../interfaces/icost-code';
import { BudgetAdjustment } from '../budget-adjustment';
import { CostCodeCategory } from '../cost-code-category';
import { CostCodeCostType } from '../cost-code-cost-type';

export class CostCodeBase {
  CostCodeId: number;
  CostCodeValue: number;
  CostCodeDescription: string;
  CostCodeCategoryId: number;
  CostCodeShortDescription: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  IsActive: boolean | null;

  BudgetAdjustments_CostCode?: Array<BudgetAdjustment> | null;
  CostCodeCostTypes_CostCode?: Array<CostCodeCostType> | null;
  CostCodeCategory?: CostCodeCategory;

  constructor(item?: ICostCode) {
    if (item) {

      this.CostCodeId = item.CostCodeId;
      this.CostCodeValue = item.CostCodeValue;
      this.CostCodeDescription = item.CostCodeDescription;
      this.CostCodeCategoryId = item.CostCodeCategoryId;
      this.CostCodeShortDescription = item.CostCodeShortDescription;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.IsActive = item.IsActive;

      this.BudgetAdjustments_CostCode = Helpers.createClassArray(BudgetAdjustment, item.BudgetAdjustments_CostCode);
      this.CostCodeCostTypes_CostCode = Helpers.createClassArray(CostCodeCostType, item.CostCodeCostTypes_CostCode);
      this.CostCodeCategory = new CostCodeCategory(item.CostCodeCategory);
    }
  }
}